type TelaErroProps = {
  motivo: string | null;
  atualizando: boolean;
  aoAtualizar: () => void;
};

/**
 * Estado terminal: nenhum snapshot foi obtido nesta sessão.
 *
 * Aqui a página não sabe nada sobre a saúde do sistema e diz exatamente isso. O
 * telefone de suporte é o conteúdo mais importante da tela — quem chegou até aqui
 * provavelmente já está com um problema em mãos.
 */
export const TelaErro = ({ motivo, atualizando, aoAtualizar }: TelaErroProps) => {
  return (
    <section className="cartao-status px-6 py-7" role="alert">
      <div className="flex items-start gap-3.5">
        <span
          aria-hidden="true"
          className="mt-2 size-3.5 flex-none rounded-full"
          style={{ background: 'var(--muted-foreground)' }}
        />
        <div className="min-w-0 flex-1">
          <h1 className="m-0 text-[30px] font-semibold tracking-[-0.025em] text-pretty">
            Não conseguimos carregar o estado dos serviços
          </h1>
          <p className="mt-2 mb-0 text-[14px] leading-[1.55] text-pretty text-muted-foreground">
            Isso pode ser uma falha momentânea da sua conexão ou da própria página de status. Não
            significa, por si só, que o sistema esteja fora do ar. Se você está com dificuldades
            agora, entre em contato com o suporte.
          </p>
        </div>
      </div>

      <div className="mt-[22px] flex flex-wrap items-center gap-3 border-t border-border pt-[18px]">
        <button
          type="button"
          onClick={aoAtualizar}
          disabled={atualizando}
          className="rounded-lg bg-primary px-4 py-2 text-[13px] font-medium text-primary-foreground transition-colors hover:bg-primary-active disabled:opacity-60"
        >
          {atualizando ? 'Tentando…' : 'Tentar novamente'}
        </button>
        {motivo && <span className="text-[12px] text-muted-foreground">{motivo}</span>}
      </div>
    </section>
  );
};
